module.exports = __webpack_public_path__ + "images/bfp_small1a0f642eb6129c286eca218f1cdc2558.png";